import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function EmbedRequired({ direction = 'ltr' }) {
    const { t } = useTranslation();

    return (
        <Box
            dir={direction}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                width: '100%',
                padding: 3,
            }}
        >
            <Typography variant="h6" component="p">
                {t('embed_required_title')}
            </Typography>
            <Typography variant="body2" component="p" sx={{ marginTop: 1 }}>
                {t('embed_required_message')}
            </Typography>
        </Box>
    );
}

export default EmbedRequired;
